<template>
  <div>
    <AddRetainershipModal :company="company"></AddRetainershipModal>
    <AddNewRetainershipModal :company="company"></AddNewRetainershipModal>
    <EditCreditLimit
      :creditLimit="creditLimit"
      :clientId="clientId"
      :companyID="companyID"
    ></EditCreditLimit>

    <WalletTopUp :clientId="clientId" :companyID="companyID"></WalletTopUp>
    <SetCardChargeModal
      :companyID="companyID"
      :currentCardCharge="cardCharge"
    ></SetCardChargeModal>
    <MasterLayout>
      <!-- LOADER -->
      <section class="row card-loader-wrapper w-100" v-if="showLoader">
        <div
          class="col-md-3 position-relative mb-2"
          v-for="(c, i) in 4"
          :key="i"
        >
          <div class="card-loader"></div>
        </div>
        <!-- LOADER -->
        <div
          class="showLoaderDiv charts__loader w-full mt-5 rounded-lg w-full"
          style="width: 130% !important; height: 100%"
          v-if="showLoader"
        >
          <div :class="showLoader ? 'loading' : null"></div>
        </div>
        <!-- END LOADER -->
      </section>
      <!-- END LOADER -->

      <section v-if="!showLoader">
        <section>
          <div class="fuelbalance_first_row">
            <div class="row w-100">
              <div class="col-sm-12 col-lg-3">
                <div
                  style="background-color: #46266e; color: white"
                  class="d-flex justify-content-between overview-card p-4 px-10"
                >
                  <div class="">
                    <h5>{{ $t("text.cWallet.walletBalance") }}</h5>
                    <p class="mt-3">{{ walletBalance }}</p>
                  </div>
                </div>
              </div>

              <div
                v-for="(card, index) in cards"
                :key="index"
                class="col-sm-12 col-lg-3"
              >
                <div
                  class="d-flex shadow-sm justify-content-between overview-card p-4 px-10"
                >
                  <div class="">
                    <h5>{{ card.title }}</h5>

                    <p class="mt-3" v-if="card.id == 1">
                      {{ totalCards }}
                    </p>

                    <p class="mt-3" v-if="card.id == 2">
                      {{ unissuedCards }}
                    </p>

                    <p class="mt-3" v-if="card.id == 3">
                      {{ issuedCards }}
                    </p>
                  </div>

                  <div>
                    <img src="@/assets/svg/wallet.svg" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section class="d-flex justify-content-end mr-4">
            <button
              class="py-2 px-3 text-white"
              style="
                background-color: #46266e;
                border: none;
                border-radius: 5px;
                font-size: 14px;
              "
              @click="showAddNewRetainershipModal"
            >
              {{ $t("text.companyRetainership.addNew") }}
              <img
                src="@/assets/img/paper-plane.png"
                width="25px"
                class="ml-3"
              />
            </button>

            <button
              class="ml-2 py-2 px-3 text-white"
              style="
                background-color: #46266e;
                border: none;
                border-radius: 5px;
                font-size: 14px;
              "
              @click="showsetCardChargeModal"
            >
              {{ $t("text.retainership.setCardCharge") }}
            </button>
          </section>
        </section>

        <section class="section__row mt-3">
          <div class="">
            <div class="position-relative">
              <ejs-grid
                v-show="!showLoader"
                ref="dataGrid"
                :created="refreshGrid"
                :allowPaging="true"
                :allowSorting="true"
                :pageSettings="pageSettings"
                :toolbar="toolbar"
                :searchSettings="search"
                :allowExcelExport="true"
                :allowPdfExport="true"
                :toolbarClick="toolbarClick"
                :excelQueryCellInfo="excelQueryCellInfo"
                :locale="usedLang"
              >
                <e-columns>
                  <e-column width="40" field="index" headerText="#"></e-column>

                  <e-column
                    width="200"
                    :template="RetainTemp"
                    :headerText="$t('text.products.name')"
                  ></e-column>

                  <e-column
                    width="150"
                    field="username"
                    :headerText="$t('text.resetPassword.userName')"
                  ></e-column>

                  <!-- <e-column
                      field="name"
                      width="200"
                      :headerText="$t('text.products.name')"
                    ></e-column> -->

                  <e-column
                    field="state"
                    width="150"
                    :headerText="$t('text.drivers.state')"
                  ></e-column>

                  <e-column
                    field="email"
                    width="270"
                    :headerText="$t('text.companyRetainership.email')"
                  ></e-column>

                  <e-column
                    field="phoneNumber"
                    width="200"
                    :headerText="$t('text.drivers.phoneNumber')"
                  ></e-column>

                  <e-column
                    field="cards"
                    width="150"
                    format="N"
                    :headerText="$t('text.cards.cards')"
                  ></e-column>

                  <e-column
                    field="balance"
                    width="200"
                    format="N"
                    :headerText="$t('text.subAccounts.balance')"
                  ></e-column>

                  <e-column
                    field="points"
                    width="150"
                    format="N"
                    :headerText="$t('text.companyRetainership.loyaltyPts')"
                  ></e-column>

                  <e-column
                    field="creditLimit"
                    width="200"
                    format="N"
                    :headerText="$t('text.companyRetainership.creditLimit')"
                  ></e-column>

                  <!-- <e-column
                    field="address"
                    width="250"
                    :headerText="$t('text.drivers.address')"
                  ></e-column> -->

                  <!-- <e-column
                    width="150"
                    :template="RetainTemp"
                    headerText=""
                  ></e-column> -->

                  <e-column width="60" :template="optionsTemplate"></e-column>
                </e-columns>
              </ejs-grid>
              <TableLoader :showLoader="showLoader" />
              <DropDown :details="details" />
            </div>
          </div>
        </section>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/BecomeDealer.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import RetainTemp from "@/components/Templates/retainTemp";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import SetCardChargeModal from "@/components/modals/Remis/Retainership/setCardCharge";

import AddRetainershipModal from "@/components/modals/addRetainershipModal";
import AddNewRetainershipModal from "@/components/modals/addNewRetainershipModal";
import EditCreditLimit from "@/components/modals/Retainership/editCreditLimit";
import WalletTopUp from "@/components/modals/Retainership/walletTopUp";
import DropDown from "@/components/Templates/Dropdown/companyRetainershipDropdown.vue";
import RetTemp from "@/components/Templates/companyRetainershipTemplate.vue";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Retainership :: Epump Portal",
  name: "Retainership",
  components: {
    MasterLayout,
    AddRetainershipModal,
    AddNewRetainershipModal,
    EditCreditLimit,
    TableLoader,
    DropDown,
    RetainTemp,
    SetCardChargeModal,
    WalletTopUp,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      cardCharge: 0,
      totalCards: 0,
      issuedCards: 0,
      unissuedCards: 0,
      walletBalance: 0,
      cards: [
        {
          id: 1,
          title: this.$t("text.retainership.totalCards"),
        },

        {
          id: 2,
          title: this.$t("text.retainership.issuedCard"),
        },

        {
          id: 3,
          title: this.$t("text.retainership.unissuedCard"),
        },
      ],

      usedLang: this.$store.getters.getLanguage,
      corpId: null,
      backgroundUrl,
      cardBackgroundUrl,
      fuelBalance: 0,
      walletTransactions: null,
      showLoader: true,
      totalTransactions: null,
      tableDataCount: 10,
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      retainerships: null,
      retainershipCount: 0,
      creditLimit: "",
      clientId: "",
      email: "",
      company: null,
      companyID: this.$route.query.companyId
        ? this.$route.query.companyId
        : this.company
        ? this.company.id
        : "",
      details: {
        data: { status: "" },
        queryStrings: { id: "", companyId: this.$route.query.companyId },
        info: [
          {
            name: this.$t("text.retainership.walletTopup"),
            emitName: "walletTopup",
          },
          {
            name: this.$t("text.assets.updateCreditLimit"),
            emitName: "updateCreditLimit",
          },
          {
            name: this.$t("text.assets.walletTransactions"),
            emitName: "walletTransactions",
          },
        ],
        delete: {
          hasDelete: false,
          deleteName: "deleteInvoice",
          name: "Delete",
          query: "id",
        },
      },
      optionsTemplate: function () {
        return {
          template: RetTemp,
        };
      },
      RetainTemp: function () {
        return {
          template: RetainTemp,
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });

    if (this.$route.query.companyId) {
      const remisHash = JSON.parse(localStorage.getItem("rHash"));
      if (!remisHash) {
        this.getRemisHash();
      } else {
        this.callEndpoints();
      }
    }

    this.$eventHub.$on("companyRetainershipData", (data) => {
      this.details.data = data;
      this.details.queryStrings.clientDetails = data;
      this.details.queryStrings.id = data.id;
      this.details.queryStrings.walletId = data.walletId;
      this.details.queryStrings.name = data.firstName;

      const option = document.getElementById("myDropdown");
      option.classList.add("show");

      let index;

      if (data.index > 10 && parseInt(data.index.toString().slice(1)) === 0) {
        index = 10;
      }
      if (data.index > 10 && parseInt(data.index.toString().slice(1)) > 0) {
        index = parseInt(data.index.toString().slice(1));
      }

      if (data.index <= 10) {
        index = data.index;
      }

      option.style.top = `${(80 * index + (85 - index * 2)).toString()}px`;
    });

    this.$eventHub.$on(this.details.info[0].emitName, (queryStrings) => {
      this.openWalletTopupModal(queryStrings);
    });

    this.$eventHub.$on(this.details.info[1].emitName, (queryStrings) => {
      this.updateCreditLimit();
    });

    this.$eventHub.$on(this.details.info[2].emitName, (queryStrings) => {
      this._walletTransactions(queryStrings);
    });

    this.$eventHub.$on("getRetainerships", () => {
      this.callEndpoints();
    });
    this.$eventHub.$on("changeRetainership", (route, id, walletId, name) => {
      this.changeRoute(route, id, walletId, name);
    });
    this.$eventHub.$on("setCreditLimit", (creditLimit, clientId) => {
      this.creditLimit = creditLimit;
      this.clientId = clientId;
    });

    this.$eventHub.$on("openWalletTopUp", (clientDetails) => {
      this.clientId = clientDetails.clientId;
    });
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.companyID = this.$route.query.companyId
          ? this.$route.query.companyId
          : company.id;
        const remisHash = JSON.parse(localStorage.getItem("rHash"));
        this;
        if (!remisHash) {
          this.getRemisHash();
        } else {
          this.callEndpoints();
        }
      }
    },
  },

  beforeDestroy() {
    // this.$eventHub.$off("getRetainerships");
    this.$eventHub.$off("changeRetainership");
    this.$eventHub.$off("setCreditLimit");
  },

  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    //utilities
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },

    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    revertNumber(number) {
      return Number(number.replace(/[^0-9.]+/g, ""));
    },

    //modals

    showAddNewRetainershipModal() {
      this.$modal.show("addNewRetainershipModal");
    },

    showAddNewRetainershipModal() {
      this.$modal.show("addNewRetainershipModal");
    },

    showsetCardChargeModal() {
      this.$modal.show("setCardChargeModal");
    },

    //requests

    callEndpoints() {
      this.getRetainerships();
      this.getCardCharge();
      this.getDashboardDetails();
    },

    getDashboardDetails() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/Dashboard/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          console.log();
          this.walletBalance = this.convertThousand(response.data.balance);
          this.totalCards = response.data.totalCard;
          this.issuedCards = response.data.issuedCards;
          this.unissuedCards = response.data.availableCards;
          console.log(response);

          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;

          let customError;
          if (error.response) {
            customError = error.response.data.message;
          } else {
            customError = error.message;
          }

          console.log(error);
          this.$toast.open({
            message: customError,
            type: "error",
            duration: 5000,
          });
        });
    },

    getRemisHash() {
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.apiBaseUrl}/Account/RemisHash`,
          configObject.authConfig()
        )
        .then((response) => {
          localStorage.setItem("rHash", JSON.stringify(response.data));

          this.callEndpoints();
        })
        .catch((error) => {});
    },

    getFuelBalance() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Wallet/Balance?id=${this.corpId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.fuelBalance = response.data.balance
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        })
        .catch((error) => {});
    },

    getCardCharge() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/Customer/CardCharge/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          this.showLoader = false;

          this.cardCharge = response.data.data;
        })
        .catch((error) => {
          this.showLoader = false;

          let customError;
          if (error.response) {
            customError = error.response.data.message;
          } else {
            customError = error.message;
          }

          console.log(error);
          this.$toast.open({
            message: customError,
            type: "error",
            duration: 5000,
          });
        });
    },

    // get registered retainership companies
    getRetainerships() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.remisBaseUrl}/D/Retainership/Customer/Clients/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig({ isRemis: true })
        )
        .then((response) => {
          let index = 0;
          response.data.data.sort((a, b) => {
            if (a.orderBy < b.orderBy) {
              return 1;
            } else {
              return -1;
            }
          });
          response.data.data.forEach((element) => {
            index++;
            element.index = index;
            element.points = 0;
            element.state = element.state !== "" ? element.state : "Lagos";
          });

          if (this.$refs.dataGrid) {
            this.$refs.dataGrid.ej2Instances.setProperties({
              dataSource: response.data.data,
            });
            this.refreshGrid();
          }

          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;

          let customError;
          if (error.response) {
            customError = error.response.data.message;
          } else {
            customError = error.message;
          }

          console.log(error);
          this.$toast.open({
            message: customError,
            type: "error",
            duration: 5000,
          });
        });
    },

    openWalletTopupModal(queryStrings) {
      this.$eventHub.$emit("openWalletTopUp", queryStrings.clientDetails);
      this.$modal.show("walletTopup");
    },
    _walletTransactions(queryStrings) {
      // this.changeRoute(
      //   "RetainershipWalletTransactions",
      //   queryStrings.id,
      //   queryStrings.walletId,
      //   queryStrings.name
      // );
    },
    updateCreditLimit() {
      this.$eventHub.$emit(
        "setCreditLimit",
        this.details.data.creditLimit,
        this.details.data.clientId
      );
      this.$modal.show("editCreditLimit");
    },

    changeRoute($newRoute, id, walletId, name) {
      this.$router.push({
        name: $newRoute,
        query: {
          id: id,
          walletId,
          name,
          companyId: this.$route.query.companyId,
        },
      });
    },
    showFundWalletModal() {
      this.$modal.show("fund-wallet-payweall");
    },
    showAddRetainershipModal() {
      this.$modal.show("addRetainershipModal");
    },
  },
};
</script>

<style>
.overview-card {
  background-color: white;
  border: 1px solid #f3f4f5;
  color: #667085;
  border-radius: 10px;
  margin-bottom: 20px;
}

.overview-card h5 {
  font-size: 13px;
  text-transform: uppercase;
}

.overview-card p {
  font-weight: 700;
}
@media screen and (max-width: 602px) {
  .addNewRetainershipModal .v--modal-box.v--modal {
    margin: 0 auto;
    top: 150px !important;
    width: 90% !important;
    height: 500px !important;
    left: 0 !important;
    overflow: auto;
  }
  .addRetainershipModal .v--modal-box.v--modal {
    margin: 0 auto;
    /* top: 88px !important; */
    width: 90% !important;
    height: 379px !important;
    left: 0 !important;
    overflow: auto;
  }
  button.add_quick_fuel_btn {
    margin-bottom: 62px;
  }
}
</style>
